import cn from 'classnames'

import { SortEnum } from '@interfaces/SortEnum'
import { HeaderWithSortProps } from './interface'

export function HeaderWithSort({
  text,
  sortKey,
  sortValue,
  sortKeySelected,
  onClick,
}: HeaderWithSortProps) {
  function handleSort() {
    if (sortKey === sortKeySelected) {
      onClick(
        sortKey,
        sortValue === SortEnum.ASC ? SortEnum.DESC : SortEnum.ASC
      )
    } else {
      onClick(sortKey, SortEnum.ASC)
    }
  }

  return (
    <button
      className='flex space-x-[4px] desktop-tablet:p-[10px] w-full bg-white dark:bg-transparent'
      type='button'
      onClick={handleSort}
    >
      <div className='text-secondary-1 text-[12px] font-bold'>{text}</div>
      <div>
        <div
          className={cn(
            'w-[9px] h-[7px] border-b-[7px] border-l-[4.5px] border-r-[4.5px] border-l-transparent border-r-transparent',
            {
              'border-b-gray-3': !(
                sortKeySelected === sortKey && sortValue === SortEnum.DESC
              ),
              'border-b-gray-10':
                sortKeySelected === sortKey && sortValue === SortEnum.DESC,
            }
          )}
        />
        <div
          className={cn(
            'w-[9px] h-[7px] mt-[2px] border-t-[7px] border-l-[4.5px] border-r-[4.5px] border-l-transparent border-r-transparent',
            {
              'border-t-gray-3': !(
                sortKeySelected === sortKey && sortValue === SortEnum.ASC
              ),
              'border-t-gray-10':
                sortKeySelected === sortKey && sortValue === SortEnum.ASC,
            }
          )}
        />
      </div>
    </button>
  )
}
